import { getJSON } from 'redux-api-middleware';
import apiService from 'src/services/api-service';
import {
  GET_SEARCH_FEATURES_FAILURE,
  GET_SEARCH_FEATURES_REQUEST,
  GET_SEARCH_FEATURES_SUCCESS
} from 'stores/flow-type/search-control.type';

export const getSearchControlFeatureStatus = () => {
  return apiService.sendRequest('admin-v3.search-control.feature-status', {}, [
    GET_SEARCH_FEATURES_REQUEST,
    {
      type: GET_SEARCH_FEATURES_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    },
    {
      type: GET_SEARCH_FEATURES_FAILURE,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    }
  ]);
};